import React, { useContext, useEffect, useRef, useState } from "react";
import {
  FaArrowLeft,
  FaCheckCircle,
  FaSearch,
  FaTrash,
  FaTrashRestore,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

import { axiosServer } from "../../../axiosServer";
import buildLink from "../../../urls";
import MessageAlert from "../../../components/messageAlert";
import { BsBookshelf } from "react-icons/bs";
import { CompanyContext } from "../../../contexts/companyCotext";
import Loader from "../../../components/loader";
import { IoMdRemoveCircleOutline } from "react-icons/io";
import Cookies from "js-cookie";
import { PlaySounds } from "../../../functions/playSounds";
import hocStarredPage from "../../../components/hocStarredPage";
import axios from "axios";
import { FaExchangeAlt } from "react-icons/fa";

const ChangeProductAddress = () => {
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const [disabledInputs, setDisabledInputs] = useState(true);
  const [counter, setCounter] = useState(0);
  const [showScan, setShowScan] = useState(false);
  const [finished, setFinished] = useState(false);
  const [ScannedQty, setScannedQty] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [loadingAssign, setLoadingAssign] = useState(false);
  const productId = useRef(null);
  const scannedProductId = useRef(null);
  const binId = useRef(null);
  // const warehouseid = useRef(null);
  const binqtyinput = useRef(null);
  const qty = useRef(null);
  const [products, setProducts] = useState(null);
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [productInfo, setProductInfo] = useState(null);
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [message, setMessage] = useState("");
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [action, setAction] = useState();
  const [Action, setaction] = useState();
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingSearch1, setLoadingSearch1] = useState(false);
  const [start, setStart] = useState(false);
  const [assign, setAssign] = useState(false);
  const scanRef = useRef(null);
  const [stateCom, dispatchCom] = useContext(CompanyContext);
  const [counterOnScan, setcounterOnScan] = useState();
  const [requestSuccess, setRequestSuccess] = useState(false);
  const [productInf, setProductInf] = useState(null);
  const [keyboardType, setKeyboardType] = useState("text");
  const [processingRequest, setProcessingRequest] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [allowContinuecheckBin, setAllowContinueCheckBin] = useState(false);
  const Oldbinid = useRef(null);
  // const [fetchedOldBinId, setFetchedOldBinId] = useState("");
  const [ShowProductInput, setShowProductInput] = useState(false);
  const [ShowBinQuantityInput, setShowBinQuantityInput] = useState(false);
  const [quantityCounter, setQuantityCounter] = useState(0);
  const NewBinId = useRef(null);
  const changedquantity = useRef(null);
  const [isBinForm, setisBinForm] = useState(false);
  const productIdInputRef = useRef(null);
  const [oldBin, setOldBin] = useState("");
  const [binQuantity, setBinQuantity] = useState(null);
  const [ShowChangedQuantityInput, setShowChangedQuantityInput] =
    useState(false);
  const [standQuantity, setstandQuantity] = useState(null);
  const [productIdInput, setProductIdInput] = useState("");
  const [selectedWarehouseId, setSelectedWarehouseId] = useState("7");
  const [showSubmit, setShowSubmit] = useState(false);
  const [host, setHost] = useState(window.location.host);

  useEffect(() => {
    setHost(window.location.host);
  }, [host]);

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // useEffect(() => {
  //   if (productInf && productInf.address && allowContinuecheckBin) {
  //     setOpenAlert(false);
  //     getBinInfo();
  //   }
  // }, [allowContinuecheckBin, productInf]);

  // const getBinInfoCheck = (e) => {
  //   e.preventDefault();
  //   getBinInfo();
  // };

  const warehouseID = selectedWarehouseId; // Get the warehouse ID from the state

  useEffect(() => {
    console.log("finished", finished);
  }, [finished]);
  const searchProduct = async (e) => {
    e.preventDefault();
    setAllowContinueCheckBin(false);
    setLoadingSearch(true);

    const item = productId.current.value;

    try {
      const url =
        buildLink("getWarehouseProductDetails") +
        `&product=${item}` +
        `&warehouse_id=${warehouseID}`;
      await axiosServer.get(url).then((response) => {
        if (response.data.success) {
          setProductInf(response.data.product);
          if (response.data.product.bin_id !== "" && activeTab === 1) {
            setMessage(
              "this product has bin, please unassign product from bin first",
            );
            setShowMessageErr(true);
            setTimeout(() => {
              setShowMessageErr(false);
              setActiveTab(2);
            }, 3000);
            playErrorSound();
          } else {
            setMessage(response.data.success);
            setShowMessageSucc(true);
            setTimeout(() => {
              setShowMessageSucc(false);
            }, 3000);
            playSuccessSound();
          }
          if (activeTab === 3) {
            if (host === "pda.ishtari.com" && stateCom.userID == "1371") {
              setOldBin(response?.data?.product?.bin_id);
            }
            if (host === "pda.ishtari.com") {
              setQuantity(response?.data?.product?.quantity);
              setScannedQty(response?.data?.product?.quantity);
              setShowScan(true);
              setFinished(false);
              setCounter(0);
            }

            setisBinForm(true);
          }

          playSuccessSound();
        }
      });
      setLoadingSearch(false);
    } catch (e) {
      setLoadingSearch(false);
      productId.current.focus();
      productId.current.value = "";
      playErrorSound();
      setMessage(e.response.data.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  };

  const fetchBinQuantity = async () => {
    setLoadingSearch1(true);
    const oldBinId = Oldbinid.current.value;
    const newBinId = NewBinId.current.value;
    // const fetchedoldbinid = productInf.bin_id != "" ? productInf.bin_id : 0;
    const warehouse_id = selectedWarehouseId;

    let isFinished = finished;

    if (
      counter != quantity &&
      quantity < 20 &&
      activeTab === 3 &&
      !finished &&
      host === "pda.ishtari.com"
    ) {
      setLoadingSearch1(false);
      setLoading(false);
      playErrorSound();
      setMessage("Scan all quantities before proceeding");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      scannedProductId?.current?.focus();
      return;
    } else {
      if ((counter == quantity) && counter > 0) {
        isFinished = true;
        setFinished(true);
      }
      setLoadingSearch1(true);
    }

    if (oldBinId == newBinId) {
      setLoading(false);
      playErrorSound();
      setMessage("Old bin ID and new bin ID cannot be the same");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }
    const url =
      buildLink("changeWarehouseProductBin") +
      `&user_id=${stateCom.userID}&old_bin_id=${oldBinId}&new_bin_id=${newBinId}&product_id=${productId.current.value}&bin_quantity=${productInf.bin_quantity}&warehouse_id=${warehouse_id}`;

    try {
      const response = await axiosServer.get(url);
      setLoadingSearch1(false);
      setShowScan(false);

      if (response.data.success) {
        setMessage(response.data.message);
        setShowMessageSucc(true);
        playSuccessSound();
        setShowChangedQuantityInput(true);
        setstandQuantity(response.data.standQuantity);
        setShowSubmit(true);

        setTimeout(() => {
          setShowMessageSucc(false);
        }, 3000);
        setLoadingSearch1(false);
        if (isFinished) {
          submitBinChange();
        }
        setFinished(false);

        setCounter(0);
      } else {
        setLoadingSearch1(false);
        setShowProductInput(false);
        setMessage(response.data.message);
        setShowMessageErr(true);
        playErrorSound();
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
        setLoadingSearch1(false);
      }
    } catch (e) {
      setLoadingSearch1(false);
      setShowProductInput(false);
      setMessage(e.response?.data?.message || "Something went wrong");

        if (Oldbinid.current) {
          Oldbinid.current.value = "";
          setOldBin("");
          Oldbinid.current.focus();
        }
      setShowMessageErr(true);
      playErrorSound();
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  };

  const submitBinChange = async (e) => {
    setLoading(true);

    const oldBinId = Oldbinid.current.value;
    const newBinId = NewBinId.current.value;

    let isFinished = finished;

    if (
      counter != quantity &&
      quantity < 20 &&
      activeTab === 3 &&
      !finished &&
      host === "pda.ishtari.com"
    ) {
      setLoading(false);
      playErrorSound();
      setMessage("Scan all quantities before proceeding");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    } else {
       if ((counter == quantity) && counter > 0) {
        isFinished = true;
        setFinished(true);
      }
      setShowScan(false);
      setLoading(true);
    }

    if (oldBinId === newBinId) {
      setLoading(false);
      playErrorSound();
      setMessage("Old bin ID and new bin ID cannot be the same");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }
    const warehouse_id = selectedWarehouseId;
    const obj = {
      product: productId.current.value,
      user_id: stateCom.userID,
      old_bin_id: oldBinId,
      new_bin_id: newBinId,
      warehouse_id,
    };

    const url =
      buildLink("changeWarehouseProductBin") +
      `&user_id=${stateCom.userID}&old_bin_id=${oldBinId}&new_bin_id=${newBinId}`;

    try {
      const response = await axiosServer.post(url, obj);

      setLoading(false);
      setShowSubmit(false);
      setShowScan(false);

      if (response.data.success) {
        setMessage(response.data.message || "Bin Changed");
        setShowMessageSucc(true);
        playSuccessSound();
        setTimeout(() => {
          setShowMessageSucc(false);
        }, 3000);
        productId.current.value = "";
        NewBinId.current.value = "";
        setOldBin("");
        setProductInf(null);
        setShowSubmit(false);
        setLoading(false);
        setCounter(0);
        setFinished(false);
      } else {
        setLoading(false);
        playErrorSound();
        setMessage(response.data.message || "An error occurred");
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
        productId.current.value = "";
        NewBinId.current.value = "";
        oldBinId.current.value = "";
        setProductInf(null);
        setShowSubmit(false);
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
      playErrorSound();
      setMessage(e.response?.data?.message || "An error occurred");
      if (isFinished) {
        if (Oldbinid.current) {
          Oldbinid.current.value = "";
          setOldBin("");
          Oldbinid.current.focus();
        }
      }
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  };

  useEffect(() => {
    if (quantityCounter === 0) {
      if (productId.current) {
        productId.current.value = "";
        productId.current.disabled = false;
      }
      if (Oldbinid.current) {
        Oldbinid.current.value = "";
      }
      if (NewBinId.current) {
        NewBinId.current.value = "";
      }
      setisBinForm(false);
      setProductIdInput("");
      setShowProductInput(false);
      setShowBinQuantityInput(false);
      setShowChangedQuantityInput(false);
    }
  }, [quantityCounter]);

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  useEffect(() => {
    setDisabledInputs(true);
  }, [activeTab]);

  async function getBinInfo(e) {
    e.preventDefault();
    setAllowContinueCheckBin(false);
    setLoading(true);
    const bin_id = binId.current.value;
    const product = productId.current.value;
    const warehouse_id = selectedWarehouseId;

    const obj = JSON.stringify({
      bin_id,
      product,
      warehouse_id,
    });

    try {
      const url = buildLink("getWarehouseProductInfo") + `&v2=true`;
      const response = await axiosServer.post(url, JSON.parse(obj));
      setLoading(false);
      if (response.data.success) {
        setDisabledInputs(true);
        const productInfo = response.data.data.product;
        setAction(response.data.data.action);
        setaction(response.data.data.action);
        setInfo(productInfo);
      }

      Cookies.set("productInfo", JSON.stringify(info), { expires: 7 });
      Cookies.set("action", action, { expires: 7 });
    } catch (e) {
      setLoading(false);
      console.error(e);
      playErrorSound();
      setMessage(e.response.data.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const getUserIdFromLocalStorage = () => {
    return localStorage.getItem("userID");
  };
  useEffect(() => {
    if (counter == quantity && activeTab === 3) {
      fetchBinQuantity();
    }
  }, [counter]);

  const scanProduct = (e) => {
    e.preventDefault();
    if (scannedProductId.current.value != productId.current.value) {
      playErrorSound();
      setMessage(
        "Scanned Product ID / SKU does not match the expected product.",
      );
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }
    setCounter(counter + 1);
    setScannedQty(ScannedQty - 1);

    if (scannedProductId.current) {
      scannedProductId.current.value = "";
    }
  };

  async function assignProductToBin(e) {
    e.preventDefault();
    if (processingRequest) return;
    setProcessingRequest(true);
    const userID = getUserIdFromLocalStorage();

    const warehouse_id = selectedWarehouseId;
    const action = warehouse_id ? "assign" : Action;

    if (scanRef.current.value === productId.current.value) {
      if (action === "count") {
        playSuccessSound();
        setMessage("Successfully Assigned To Bin");
        setShowMessageSucc(true);
        setTimeout(() => {
          setShowMessageSucc(false);
        }, 3000);
      } else {
        const getcookies = Cookies.get("productInfo");
        const savedData = JSON.parse(getcookies);
        const new_bin_id = binId.current.value;
        const upc = savedData.upc;
        const big_upc = savedData.big_upc;
        const bin_id = savedData.bin_id;

        const counter = counterOnScan || 0;

        const obj = {
          user_id: userID,
          new_bin_id,
          upc,
          big_upc,
          bin_id,
          action,
          counter,
          warehouse_id,
        };

        if (typeof info === "object") {
          if (info.product_option_value_id === "") {
            obj.id = info.product_id;
            obj.type = "product";
          } else {
            obj.id = info.product_option_value_id;
            obj.type = "option";
          }
        }

        try {
          const url = buildLink("assignWarehouseProductToBin") + `&v2=true`;
          await axiosServer.post(url, obj).then((response) => {
            if (response.data.success) {
              setcounterOnScan(response.data.data.counter);
              setRequestSuccess(true);
              scanRef.current.value = "";
              setProcessingRequest(false);
              if (scanRef.current) {
                scanRef.current.disabled = false;
                scanRef.current.focus();
              }
            }
            if (response.data.success && action === "assign") {
              playSuccessSound();
              setMessage("Successfully Assigned To Bin");
              setShowMessageSucc(true);
              setTimeout(() => {
                setShowMessageSucc(false);
              }, 3000);
            }
            if (
              response.data.data.done === true ||
              response.data.data.done === "true"
            ) {
              setDisabledInputs(true);
              productId.current.value = "";
              binId.current.value = "";
              setcounterOnScan(0);
              productId.current.focus();
              setStart(false);
              setProductInf(null);
              playSuccessSound();
              setMessage("Successfully Assigned To Bin");
              setShowMessageSucc(true);
              setTimeout(() => {
                setShowMessageSucc(false);
              }, 3000);
            }
          });
        } catch (e) {
          setShowMessageErr(true);
          setTimeout(() => {
            setShowMessageErr(false);
          }, 3000);
          console.log(e);
          setRequestSuccess(false);
          setProcessingRequest(false);
          if (scanRef.current) {
            scanRef.current.disabled = false;
            scanRef.current.focus();
          }
        }
      }
    } else {
      playErrorSound();
      setMessage("Please Scan The Correct Product ID");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
        if (scanRef.current) {
          scanRef.current.disabled = false;
          scanRef.current.focus();
        }
      }, 1000);
      setProcessingRequest(false);
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  async function assignProductToBin_forassign(e) {
    e.preventDefault();
    const userID = getUserIdFromLocalStorage();
    const getcookies = Cookies.get("productInfo");
    const savedData = JSON.parse(getcookies);
    const user_id = userID;
    const new_bin_id = binId.current.value;
    const upc = savedData.upc;
    const big_upc = savedData.big_upc;
    const bin_id = savedData.bin_id;

    const action = Action;
    const counter = counterOnScan || 0;
    const warehouse_id = selectedWarehouseId;
    const obj = {
      user_id,
      new_bin_id,
      upc,
      big_upc,
      bin_id,
      action,
      counter,
      warehouse_id,
    };

    if (typeof info === "object") {
      if (info.product_option_value_id === "") {
        obj.id = info.product_id;
        obj.type = "product";
      } else {
        obj.id = info.product_option_value_id;
        obj.type = "option";
      }
    }

    try {
      const url = buildLink("assignWarehouseProductToBin") + `&v2=true`;
      setLoadingAssign(true);
      await axiosServer.post(url, obj).then((response) => {
        setLoadingAssign(false);
        if (response.data.success) {
          setcounterOnScan(response.data.data.counter);
          setRequestSuccess(true);
        }
        if (response.data.success && Action === "assign") {
          playSuccessSound();
          setMessage("Successfully Assigned To Bin");

          setShowMessageSucc(true);
          setTimeout(() => {
            setShowMessageSucc(false);
          }, 3000);
        }
      });
    } catch (e) {
      setLoadingAssign(false);
      setMessage(e.response.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      console.log(e);
      setRequestSuccess(false);
    }
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  async function unassignfromBin(e) {
    e.preventDefault();
    const url = buildLink("unassignWarehouseProductFromBin") + `&v2=true`;
    const warehouse_id = selectedWarehouseId;

    const obj = {
      user_id: getUserIdFromLocalStorage(),
      bin_id: binId.current.value,
      product: productId.current.value,
      warehouse_id,
    };

    try {
      await axiosServer.post(url, obj).then((res) => {
        if (res.data.success) {
          playSuccessSound();
          setMessage(res.data.message);
          setShowMessageSucc(true);
          setTimeout(() => {
            setShowMessageSucc(false);
          }, 3000);
          setTimeout(() => {
            binId.current.value = "";
            productId.current.value = "";
            binId.current.focus();
          }, 0);
        }
      });
    } catch (e) {
      playErrorSound();
      console.log(e);
      setLoading(false);
      setMessage(e.response.data.message);
      console.log(message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const history = useNavigate();

  useEffect(() => {
    productId.current.focus();
  }, []);

  useEffect(() => {
    Cookies.set("productInfo", JSON.stringify(info), { expires: 7 });
    Cookies.set("action", action, { expires: 7 });
  }, [info, action]);

  const handleTrashClick = () => {
    Oldbinid.current.value = "";
    Oldbinid.current.focus();
  };

  const trashformschangebin = () => {
    productId.current.value = "";
    Oldbinid.current.value = "";
    NewBinId.current.value = "";
    changedquantity.current.value = "";
    productId.current.focus();
  };

  const trash = () => {
    scannedProductId.current.value = "";
  };

  const handleProductIdTrashClick = () => {
    productId.current.value = "";
    productId.current.focus();
  };

  useEffect(() => {
    setProducts(null);
    setInfo(null);
    setLoading(false);
    setShowMessageErr(false);
    setMessage("");
    setShowMessageSucc(false);
    setAction(null);
    setaction(null);
    setLoadingSearch(false);
    setStart(false);
    setAssign(false);
    setProductInf(null);
    setcounterOnScan(undefined);
    setRequestSuccess(false);
    setKeyboardType("text");
  }, [activeTab]);

  const submitchangedqty = (e) => {
    e.preventDefault();

    const enteredQuantity = parseInt(changedquantity.current.value, 10);

    if (!isNaN(enteredQuantity)) {
      setQuantityCounter(enteredQuantity);
      setShowProductInput(true);
      changedquantity.current.disabled = true;

      if (activeTab === 3) {
        setTimeout(() => {
          productIdInputRef.current.focus();
        }, 0);
      }
    } else {
      console.error("Invalid quantity entered.");
    }
  };

  const [warehouses, setWarehouses] = useState([]);
  const [changewarehouses, setchangewarehouses] = useState([]);
  const [loadingWarehouses, setLoadingWarehouses] = useState(true);
  const [error, setError] = useState("");
  const warehouseIdRef = useRef();
  const changewarehouseIdRef = useRef();

  const fetchWarehouses = async () => {
    try {
      const url = buildLink(`fetchtowarehouse`);
      const response = await axiosServer.get(url);

      if (response.data.success) {
        setWarehouses(response.data.data || []);
      } else {
        setError("Failed to fetch warehouses.");
      }
    } catch (err) {
      setError("Failed to fetch warehouses.");
    } finally {
      setLoadingWarehouses(false);
    }
  };

  useEffect(() => {
    fetchWarehouses();
  }, []);

  const handleBinChange = (e) => {
    setOldBin(e.target.value);
  };

  const handleWarehouseChange = (selectedOption) => {
    const warehouseId = selectedOption ? selectedOption.value : null;
    setSelectedWarehouseId(warehouseId);

    // Save to cookies for 1 day
    if (warehouseId) {
      Cookies.set("selectedWarehousemanageupc", warehouseId, { expires: 1 });
    } else {
      Cookies.remove("selectedWarehousemanageupc");
    }
  };

  return (
    <>
      <div className=" h-full bg-white">
        {/* header */}
        <div className=" mb-5 sticky top-0  z-50 flex flex-col bg-white">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl my-auto">Bin</h2>
            </div>
          </div>
        </div>

        <div className=" w-screen  bg-white my-4 container overflow-x-auto">
          <div className=" flex w-full justify-start gap-3 mx-1">
            <button
              onClick={() => setActiveTab(1)}
              className={`${
                activeTab === 1 ? "bg-dbase text-white" : "bg-white text-dblack"
              }  transition-all w-full py-2 text-sm  rounded-full text-nowrap px-2 `}
            >
              {" "}
              Assign to Bin
            </button>
            <button
              onClick={() => setActiveTab(2)}
              className={`${
                activeTab === 2 ? "bg-dbase text-white" : "bg-white text-dblack"
              }  transition-all w-full py-2 rounded-full text-sm text-nowrap px-3`}
            >
              {" "}
              UnAssign from Bin
            </button>
            <button
              onClick={() => setActiveTab(3)}
              className={`${
                activeTab === 3 ? "bg-dbase text-white" : "bg-white text-dblack"
              }  transition-all w-full py-2 rounded-full text-sm  text-nowrap px-3`}
            >
              {" "}
              Change Bin
            </button>
          </div>
        </div>

        {activeTab === 3 && (
          <div className="container">
            <div className="relative flex-1 mb-3">
              <label className="block  font-medium mb-1">Warehouse</label>
              <Select
                placeholder="Warehouse"
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderRadius: "7px",
                    borderColor: state.isFocused ? "grey" : "grey",
                    padding: "8px 5px",
                  }),
                }}
                options={
                  warehouses.length > 0
                    ? warehouses.map((warehouse) => ({
                        value: warehouse.warehouse_id,
                        label: warehouse.warehouse_name,
                      }))
                    : []
                }
                onChange={(selectedOption) =>
                  setSelectedWarehouseId(selectedOption.value)
                }
                value={
                  selectedWarehouseId
                    ? warehouses
                        .map((warehouse) => ({
                          value: warehouse.warehouse_id,
                          label: warehouse.warehouse_name,
                        }))
                        .find((option) => option.value === selectedWarehouseId)
                    : null
                }
              />
            </div>
            <form
              onSubmit={(e) => searchProduct(e)}
              className="flex flex-row justify-center items-end gap-3"
            >
              <div className="relative flex-1">
                <label className="block font-medium mb-1 ">
                  Product ID or SKU
                </label>
                <input
                  required
                  ref={productId}
                  type="text"
                  className="border border-dlabelColor disabled:bg-dplaceHolder outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                  placeholder="Product ID or SKU"
                />
                <div onClick={() => trashformschangebin()}>
                  <FaTrash className="absolute top-12 transform -translate-y-1/2 right-3 cursor-pointer opacity-20" />
                </div>
              </div>

              <button
                type="submit"
                className="bg-dbase rounded-md text-white px-5 h-12"
              >
                {loadingSearch ? <Loader /> : <FaSearch />}
              </button>
            </form>

            {isBinForm && (
              <form className="mt-5">
                <div className="flex flex-row justify-center gap-3 mt-5">
                  <div className="relative flex-1">
                    <label className="block font-medium mb-1 ">
                      Old Bin ID
                    </label>

                    <input
                      required
                      ref={Oldbinid}
                      value={oldBin}
                      onChange={handleBinChange}
                      type="text"
                      className="border border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                      placeholder="Old Bin ID"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          NewBinId.current.focus();
                        }
                      }}
                    />
                    <FaTrash
                      onClick={() => (Oldbinid.current.value = "")}
                      className="absolute top-1/2 mt-3 transform -translate-y-1/2 right-3 cursor-pointer opacity-20"
                    />
                  </div>
                </div>

                <div className="flex flex-row justify-center gap-3 mt-5">
                  <div className="relative flex-1">
                    <label className="block font-medium mb-1 ">
                      New Bin ID
                    </label>
                    <input
                      required
                      ref={NewBinId}
                      type="text"
                      className="border border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                      placeholder="New Bin ID"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          fetchBinQuantity();
                        }
                      }}
                    />
                    <FaTrash
                      onClick={() => (NewBinId.current.value = "")}
                      className="absolute top-1/2 mt-3 transform -translate-y-1/2 right-3 cursor-pointer opacity-20"
                    />
                  </div>

                  <button
                    type="button"
                    onClick={fetchBinQuantity}
                    className="bg-dbase rounded-md text-white px-5 h-12 mt-7"
                  >
                    {loadingSearch1 ? <Loader /> : <FaSearch />}
                  </button>
                </div>

                {quantity > 0 &&
                  quantity < 20 &&
                  showScan &&
                  ScannedQty > 0 && (
                    <div className="flex flex-row justify-center items-end gap-3 mt-3">
                      <div className="relative flex-1">
                        <div className="flex font-medium items-center mb-1 gap-2">
                          Scan Product ID or SKU{" "}
                          <span className="px-2 py-1 border rounded-lg bg-dbase text-white">
                            Counter: {ScannedQty}
                          </span>
                        </div>
                        <input
                          required
                          ref={scannedProductId}
                          type="text"
                          className="border border-dlabelColor disabled:bg-dplaceHolder outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                          placeholder="Product ID or SKU"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              scanProduct(e);
                            }
                          }}
                        />
                      </div>

                      <button
                        type="button"
                        onClick={scanProduct}
                        className="bg-dbase rounded-md text-white px-5 h-12"
                      >
                        {loadingSearch ? <Loader /> : <FaSearch />}
                      </button>
                    </div>
                  )}

                {productInf && (
                  <div className="h-full flex flex-col justify-center text-center gap-3">
                    <div className="flex gap-2 justify-center  flex-row my-4">
                      <div className="h-full my-auto w-full">
                        <img className=" w-64 h-64" src={productInf.image} />
                      </div>
                      <div>
                        <div>
                          <h2 className="text-start font-bold">Product :</h2>
                          <table className="w-full ">
                            <tbody>
                              <tr>
                                <td
                                  colSpan={2}
                                  className="border text-center border-dlabelColor px-2 py-2 whitespace-pre-wrap"
                                >
                                  Sku: {productInf.sku}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  colSpan={2}
                                  className="border text-center border-dlabelColor px-2 py-2 whitespace-pre-wrap"
                                >
                                  Quantity: {productInf.quantity}
                                </td>
                              </tr>
                              <tr>
                                {!productInf.option_name && (
                                  <td
                                    colSpan={2}
                                    className="border text-center border-dlabelColor px-2 py-2"
                                  >
                                    Big Upc: {productInf.big_upc || "_"}
                                  </td>
                                )}
                              </tr>
                              {productInf.address && (
                                <tr>
                                  <td
                                    colSpan={2}
                                    className="border flex flex-col justify-center text-center border-dlabelColor px-2 py-2"
                                  >
                                    <strong>Address:</strong>{" "}
                                    <span>{productInf.address}</span>
                                  </td>
                                </tr>
                              )}
                              {productInf.upc && !productInf.bin && (
                                <div className="flex flex-col">
                                  <td className="border text-center border-dlabelColor px-2 py-2">
                                    Upc: {productInf.upc}
                                  </td>
                                  <td className="border text-center border-dlabelColor px-2 py-2">
                                    Min Upc:{" "}
                                    {productInf.min_upc_quantity || "_"}
                                  </td>
                                  <td className="border text-center border-dlabelColor px-2 py-2">
                                    Max Upc:{" "}
                                    {productInf.max_upc_quantity || "_"}
                                  </td>
                                  <td className="border text-center border-dlabelColor px-2 py-2">
                                    Upc Qty: {productInf.upc_quantity || "_"}
                                  </td>
                                </div>
                              )}
                              {!productInf.upc && productInf.bin && (
                                <>
                                  <td className="border text-center border-dlabelColor px-2 py-2">
                                    Bin: {productInf.bin}
                                  </td>
                                  <td className="border text-center border-dlabelColor px-2 py-2">
                                    Min Bin:{" "}
                                    {productInf.min_bin_quantity || "_"}
                                  </td>
                                  <td className="border text-center border-dlabelColor px-2 py-2">
                                    Max Bin:{" "}
                                    {productInf.max_bin_quantity || "_"}
                                  </td>
                                  <td className="border text-center border-dlabelColor px-2 py-2">
                                    Bin Qty: {productInf.bin_quantity || "_"}
                                  </td>
                                  <td className="border text-center border-dlabelColor px-2 py-2">
                                    Address: {productInf.address || "_"}
                                  </td>
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="w-full rounded-lg border   bg-dplaceHolder py-3">
                      In Stand Qty : {productInf.in_stand_quantity}
                    </div>
                  </div>
                )}
              </form>
            )}
            {showSubmit && (
              <div className="flex justify-center">
                <button
                  type="submit"
                  onClick={submitBinChange}
                  className="bg-dbase rounded-md text-white  flex justify-center px-5 mt-3 py-1"
                >
                  {loading ? <Loader /> : <p>Change</p>}
                </button>
              </div>
            )}
          </div>
        )}

        {activeTab === 1 && (
          <>
            <div className="container">
              <form className="flex flex-col justify-center gap-3">
                <div className="relative flex-1">
                  <label className="block font-medium mb-1 ">Warehouse</label>
                  <Select
                    placeholder="Select Warehouse"
                    required
                    onChange={handleWarehouseChange}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderRadius: "7px",
                        borderColor: state.isFocused ? "grey" : "grey",
                        padding: "8px 5px",
                      }),
                    }}
                    options={
                      warehouses.length > 0
                        ? warehouses.map((warehouse) => ({
                            value: warehouse.warehouse_id,
                            label: warehouse.warehouse_name,
                          }))
                        : []
                    }
                    value={
                      selectedWarehouseId
                        ? warehouses
                            .map((warehouse) => ({
                              value: warehouse.warehouse_id,
                              label: warehouse.warehouse_name,
                            }))
                            .find(
                              (option) => option.value === selectedWarehouseId,
                            )
                        : null
                    }
                    className="w-full"
                  />
                </div>

                <div className="flex flex-row items-end gap-3">
                  <div className="relative flex-1">
                    <label className="block  font-medium mb-1 ">
                      Product ID or SKU
                    </label>
                    <input
                      required
                      ref={productId}
                      type="text"
                      className="border border-dlabelColor disabled:bg-dplaceHolder outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                      placeholder="Product ID or SKU"
                    />
                    <div onClick={() => handleProductIdTrashClick()}>
                      <FaTrash className="absolute top-12 transform -translate-y-1/2 right-3 cursor-pointer opacity-20" />
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="bg-dbase rounded-md text-white px-5 h-12"
                    onClick={(e) => searchProduct(e)}
                  >
                    {loadingSearch ? <Loader /> : <FaSearch />}
                  </button>
                </div>
              </form>

              <form onSubmit={(e) => getBinInfo(e)}>
                <div className=" flex flex-row justify-center gap-3  mt-5">
                  <div className="relative flex-1">
                    <label className="block  font-medium mb-1 ">Bin ID</label>
                    <input
                      required
                      ref={binId}
                      type="text"
                      className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                      placeholder="Bin ID"
                    />
                    <div>
                      <FaTrash
                        onClick={() => handleTrashClick()}
                        className="absolute top-12 transform -translate-y-1/2 right-3 cursor-pointer opacity-20 "
                      />
                    </div>
                  </div>
                </div>

                {/* <div className=" flex flex-row justify-center gap-3  mt-5">
                  <div className="relative flex-1">
                    <input
                      required
                      ref={qty}
                      type="text"
                      className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                      placeholder="Quantity"
                    />
                    <div onClick={() => (productId.current.value = "")}>
                      <FaTrash className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20 " />
                    </div>
                  </div>
                  <button
                    type="submit"
                    className=" bg-dbase rounded-md text-white px-5 "
                  >
                    {" "}
                    {loading ? <Loader /> : <FaSearch />}{" "}
                  </button>
                </div> */}
              </form>

              {productInf && (
                <div className="h-full flex flex-col justify-center text-center gap-3">
                  <div className="flex gap-2 justify-center  flex-row my-4">
                    <div className="h-full my-auto  lg:ml-80 w-full items-center">
                      <img className=" w-80 h-80" src={productInf.image} />
                    </div>
                    <div>
                      <div>
                        <h2 className="text-start font-bold">Product :</h2>
                        <table className="w-full ">
                          <tbody>
                            <tr>
                              <td
                                colSpan={2}
                                className="border text-center border-dlabelColor px-2 py-2 whitespace-pre-wrap"
                              >
                                Sku: {productInf.sku}
                              </td>
                            </tr>
                            <tr>
                              <td
                                colSpan={2}
                                className="border text-center border-dlabelColor px-2 py-2 whitespace-pre-wrap"
                              >
                                Quantity: {productInf.quantity}
                              </td>
                            </tr>
                            <tr>
                              {!productInf.option_name && (
                                <td
                                  colSpan={2}
                                  className="border text-center border-dlabelColor px-2 py-2"
                                >
                                  Big Upc: {productInf.big_upc || "_"}
                                </td>
                              )}
                            </tr>
                            {productInf.address && (
                              <tr>
                                <td
                                  colSpan={2}
                                  className="border flex flex-col justify-center text-center border-dlabelColor px-2 py-2"
                                >
                                  <strong>Address:</strong>{" "}
                                  <span>{productInf.address}</span>
                                </td>
                              </tr>
                            )}
                            {productInf.upc && !productInf.bin && (
                              <div className="flex flex-col">
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Upc: {productInf.upc}
                                </td>
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Min Upc: {productInf.min_upc_quantity || "_"}
                                </td>
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Max Upc: {productInf.max_upc_quantity || "_"}
                                </td>
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Upc Qty: {productInf.upc_quantity || "_"}
                                </td>
                              </div>
                            )}
                            {!productInf.upc && productInf.bin && (
                              <>
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Bin: {productInf.bin}
                                </td>
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Min Bin: {productInf.min_bin_quantity || "_"}
                                </td>
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Max Bin: {productInf.max_bin_quantity || "_"}
                                </td>
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Bin Qty: {productInf.bin_quantity || "_"}
                                </td>
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Address: {productInf.address || "_"}
                                </td>
                              </>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="w-full rounded-lg border   bg-dplaceHolder py-3">
                    In Stand Qty : {productInf.in_stand_quantity}
                  </div>
                </div>
              )}

              {/* {info && (
             <div className={`flex container flex-row  mt-4 border rounded-md ${start ? 'bg-Energyplus bg-opacity-60' : ''} ${successBackground ? 'bg-dgreen2' : ''}`}>
                {info && <DisplayProductInfo productInfo={info} />}

                {info && (
                  <div className="object-cover h-fit w-fit rounded-md m-auto container">
                    {info.mobile_image && <img src={info.mobile_image} />}
                    {!info.mobile_image && info.popup && (
                      <img src={info.popup} />
                    )}
                    {!info.mobile_image && !info.popup && info.thumb && (
                      <img src={info.thumb} />
                    )}
                  </div>
                )}
              </div>)} */}
            </div>
            <div>
              {!start && action && action === "count" && (
                <button
                  onClick={() => setStart(true) && scanRef.current.focus()}
                  className="bg-dbase border border-dblack container rounded-md p-3 text-white mt-3"
                >
                  Start
                </button>
              )}
              <form
                onSubmit={(e) => assignProductToBin(e)}
                className="container"
              >
                {start && action && action === "count" && (
                  <div className="flex flex-row border-dblack rounded-lg text-center max-w-sm mx-auto container ">
                    <input
                      ref={scanRef}
                      type="text"
                      autoFocus
                      className="border border-dblack rounded-lg block p-2.5 max-w-sm mx-auto mt-4 text-center w-full"
                      placeholder="Scan Item"
                      required
                      disabled={processingRequest}
                    />
                    {/* <button className="border border-dblack bg-dbase rounded-lg block max-w-sm mx-auto text-white px-5 ">
                      {" "}
                      {loading ? <Loader /> : <FaSearch />}{" "}
                    </button> */}
                  </div>
                )}
              </form>

              {action && action === "assign" && (
                <button
                  onClick={(e) => {
                    assignProductToBin_forassign(e);
                  }}
                  className={` flex flex-row justify-center text-center gap-2 border border-dblack container rounded-md p-3 text-white mt-3 ${
                    loadingAssign
                      ? "  bg-dplaceHolder text-dblack "
                      : "bg-dbase"
                  }`}
                  disabled={loadingAssign}
                >
                  <span>
                    {requestSuccess ? "Assigned Successfully" : "Assign"}
                  </span>
                  {loadingAssign && (
                    <div className=" w-4 h-4 relative">
                      <Loader />
                    </div>
                  )}
                </button>
              )}
              {/* {start && (
                <div class="  flex flex-col max-w-sm mx-auto mt-5">
                  <label className=" mb-1 container text-center h-fit  bg-white font-bold text-dbase border rounded-md w-fit ">
                    Counter:
                  </label>
                  <input
                    className="border-2 border-dblack rounded-lg block w-full p-2.5 text-center text-2xl"
                    placeholder="0"
                    readOnly={true}
                    value={counterOnScan}
                  />
                </div>
              )} */}
            </div>
          </>
        )}

        {activeTab === 2 && (
          <>
            <div className="container">
              <form onSubmit={(e) => unassignfromBin(e)}>
                <div className="relative flex-1 mt-5">
                  <label className="block  font-medium mb-1 ">Warehouse</label>
                  <Select
                    placeholder="Warehouse"
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderRadius: "7px",
                        borderColor: state.isFocused ? "grey" : "grey",
                        padding: "8px 5px",
                      }),
                    }}
                    options={
                      warehouses.length > 0
                        ? warehouses.map((warehouse) => ({
                            value: warehouse.warehouse_id,
                            label: warehouse.warehouse_name,
                          }))
                        : []
                    }
                    onChange={(selectedOption) =>
                      setSelectedWarehouseId(selectedOption.value)
                    }
                    value={
                      selectedWarehouseId
                        ? warehouses
                            .map((warehouse) => ({
                              value: warehouse.warehouse_id,
                              label: warehouse.warehouse_name,
                            }))
                            .find(
                              (option) => option.value === selectedWarehouseId,
                            )
                        : null
                    }
                  />
                </div>

                <div className=" flex flex-row justify-center gap-3 mt-5">
                  <div className="relative flex-1">
                    <label className="block  font-medium mb-1 ">Bin ID</label>
                    <input
                      ref={binId}
                      type="text"
                      className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                      placeholder="Bin ID"
                      required
                    />
                    <div>
                      <FaTrash
                        onClick={() => handleTrashClick()}
                        className="absolute top-12 transform -translate-y-1/2 right-3 cursor-pointer opacity-20 "
                      />
                    </div>
                  </div>
                </div>
                <div className=" flex flex-row justify-center gap-3 mt-5"></div>
                <div className=" flex flex-row justify-center items-end  gap-3 ">
                  <div className="relative flex-1">
                    <label className="block  font-medium mb-1 ">
                      Product ID or SKU
                    </label>
                    <input
                      ref={productId}
                      type="text"
                      className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                      placeholder="Product ID or SKU"
                      required
                    />
                    <div onClick={() => (productId.current.value = "")}>
                      <FaTrash className="absolute top-12 transform -translate-y-1/2 right-3 cursor-pointer opacity-20 " />
                    </div>
                  </div>
                  <button
                    type="submit"
                    className=" bg-dbase rounded-md text-white px-5 h-12 "
                  >
                    {loading ? <Loader /> : <IoMdRemoveCircleOutline />}{" "}
                  </button>
                </div>
              </form>
            </div>
          </>
        )}
        <div className="container mt-4  px-3 gap-1 flex-col  flex rounded-md ">
          {products &&
            products.map((product) => {
              return (
                <div className="container  border rounded-md border-dlabelColor flex flex-row">
                  <div>
                    <img className="  w-32" src={product.image}></img>
                  </div>
                  <div className=" flex p-3 flex-col text-start gap-1">
                    <p>
                      <strong>Sku: </strong>
                      {product.sku}
                    </p>
                    <p>
                      <strong>Barcode: </strong>
                      {product.product_id}
                    </p>
                    <p>
                      <strong>Quantity: </strong>
                      {product.quantity}
                    </p>
                  </div>
                </div>
              );
            })}
        </div>

        {openAlert && (
          <div
            onClick={() => setOpenAlert(false)}
            className=" fixed w-full h-full inset-0  bg-dblackk  bg-opacity-35 z-40 "
          ></div>
        )}
        {openAlert && (
          <div className=" fixed w-[70%] rounded-md  top-[40%] px-4 py-3 z-50 left-[13%] bg-white">
            <div className=" relative w-full h-full flex flex-col  justify-center">
              <h2 className=" text-xl text-dblackk font-bold">
                Note!. This item is in another address please{" "}
                <span className=" text-dbase">unassign </span> before assigning
                again!
              </h2>
              <div className=" w-full flex flex-row mt-5 justify-center gap-5">
                <button
                  onClick={() => {
                    setOpenAlert(false);
                  }}
                  className=" w-full py-2 bg-dbase1  text-white text-lg font-bold rounded-md"
                >
                  {" "}
                  Ok{" "}
                </button>
                {/* <button onClick={()=>{
                  setAllowContinueCheckBin(true);
                
                }} className=" w-full py-2 bg-dgreen text-white text-lg font-bold rounded-md">Yes</button> */}
              </div>
            </div>
          </div>
        )}

        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};

export default ChangeProductAddress;
